// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.affiliate-dashboard {
  --affiliate-accent: #c93312;
  --affiliate-ink: #171717;
  --affiliate-muted: #667085;
  --affiliate-border: #e8eaee;
  --affiliate-surface: #fff;
  color: var(--affiliate-ink);
}

.affiliate-dashboard__hero,
.affiliate-dashboard__panel,
.affiliate-dashboard__stat-card {
  background: var(--affiliate-surface);
  border: 1px solid var(--affiliate-border);
  border-radius: 18px;
  box-shadow: 0 4px 18px rgba(17, 24, 39, 0.05);
}

.affiliate-dashboard__hero {
  background: linear-gradient(135deg, #fff8f3 0%, #fff 58%, #faf7f3 100%);
  padding: 1.5rem 1.75rem;
}

.affiliate-dashboard__eyebrow,
.affiliate-dashboard__panel-kicker {
  color: var(--affiliate-accent);
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.affiliate-dashboard__title {
  color: var(--affiliate-ink);
  font-size: clamp(1.75rem, 3vw, 2.25rem);
  font-weight: 700;
  line-height: 1.15;
}

.affiliate-dashboard__subtitle,
.affiliate-dashboard__panel-copy {
  color: var(--affiliate-muted);
  line-height: 1.55;
}

.affiliate-dashboard__stats-grid {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

.affiliate-dashboard__stat-card {
  align-items: center;
  display: flex;
  gap: 1rem;
  min-height: 110px;
  padding: 1.1rem 1.2rem;
}

.affiliate-dashboard__stat-icon {
  align-items: center;
  border-radius: 14px;
  display: inline-flex;
  flex: 0 0 48px;
  height: 48px;
  justify-content: center;
  width: 48px;
}

.affiliate-dashboard__stat-icon--earned {
  background: #fff0eb;
  color: #c93312;
}

.affiliate-dashboard__stat-icon--balance {
  background: #eaf8ef;
  color: #16803c;
}

.affiliate-dashboard__stat-icon--referrals {
  background: #eef3ff;
  color: #315cc5;
}

.affiliate-dashboard__stat-icon--commission {
  background: #fff8dd;
  color: #a06800;
}

.affiliate-dashboard__stat-label {
  color: var(--affiliate-muted);
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
}

.affiliate-dashboard__stat-value {
  color: var(--affiliate-ink);
  font-size: 1.3rem;
  font-weight: 750;
}

.affiliate-dashboard__grid {
  display: grid;
  gap: 1rem;
  grid-template-columns: 1fr;
}

.affiliate-dashboard__panel {
  padding: 1.3rem;
}

.affiliate-dashboard__panel-heading,
.affiliate-dashboard__stripe-heading,
.affiliate-dashboard__button-row {
  align-items: center;
  display: flex;
  gap: 0.75rem;
}

.affiliate-dashboard__panel-heading {
  justify-content: space-between;
}

.affiliate-dashboard__panel-title {
  color: var(--affiliate-ink);
  font-size: 1.15rem;
  font-weight: 700;
}

.affiliate-dashboard__status {
  border-radius: 999px;
  flex-shrink: 0;
  font-size: 0.75rem;
  font-weight: 700;
  padding: 0.35rem 0.6rem;
}

.affiliate-dashboard__status--ready {
  background: #eaf8ef;
  color: #16803c;
}

.affiliate-dashboard__status--ended {
  background: #f3f4f6;
  color: #4b5563;
}

.affiliate-dashboard__referral-field {
  align-items: center;
  background: #f8f9fb;
  border: 1px solid #e8eaee;
  border-radius: 12px;
  display: flex;
  gap: 0.75rem;
  padding: 0.65rem;
}

.affiliate-dashboard__referral-field code {
  color: #475467;
  flex: 1;
  font-size: 0.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.affiliate-dashboard__button {
  align-items: center;
  border: 1px solid transparent;
  border-radius: 9px;
  cursor: pointer;
  display: inline-flex;
  font-size: 0.875rem;
  font-weight: 700;
  justify-content: center;
  min-height: 38px;
  padding: 0.55rem 0.85rem;
  transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease;
}

.affiliate-dashboard__button:hover:not(:disabled) {
  transform: translateY(-1px);
}

.affiliate-dashboard__button:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.affiliate-dashboard__button--primary {
  background: var(--affiliate-ink);
  color: #fff;
}

.affiliate-dashboard__button--primary:hover:not(:disabled) {
  background: #303030;
}

.affiliate-dashboard__button--secondary {
  background: #fff;
  border-color: #d9dde4;
  color: #344054;
}

.affiliate-dashboard__button--secondary:hover:not(:disabled) {
  background: #f7f8fa;
  border-color: #b8bec8;
}

.affiliate-dashboard__hint {
  color: #b54a11;
  font-size: 0.82rem;
  margin-top: 0.75rem;
}

.affiliate-dashboard__usage-row {
  border-top: 1px solid var(--affiliate-border);
  color: var(--affiliate-muted);
  display: flex;
  justify-content: space-between;
  padding: 0.8rem 0;
}

.affiliate-dashboard__usage-row:first-of-type {
  border-top: 0;
}

.affiliate-dashboard__usage-row strong {
  color: var(--affiliate-ink);
}

.affiliate-dashboard__stripe-icon {
  align-items: center;
  background: #eef3ff;
  border-radius: 12px;
  color: #635bff;
  display: inline-flex;
  height: 44px;
  justify-content: center;
  width: 44px;
}

.affiliate-dashboard__stripe-notice {
  align-items: flex-start;
  background: #f8f9fb;
  border: 1px solid #e8eaee;
  border-radius: 12px;
  color: #475467;
  display: flex;
  font-size: 0.9rem;
  gap: 0.6rem;
  margin: 1rem 0;
  padding: 0.8rem;
}

.affiliate-dashboard__stripe-notice svg {
  color: var(--affiliate-accent);
  flex-shrink: 0;
  margin-top: 0.05rem;
}

@media (min-width: 576px) {
  .affiliate-dashboard__stats-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 992px) {
  .affiliate-dashboard__stats-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .affiliate-dashboard__grid {
    grid-template-columns: minmax(0, 1.6fr) minmax(280px, 0.8fr);
  }
}

@media (max-width: 575px) {
  .affiliate-dashboard__hero,
  .affiliate-dashboard__panel {
    padding: 1rem;
  }

  .affiliate-dashboard__panel-heading {
    align-items: flex-start;
    flex-direction: column;
  }

  .affiliate-dashboard__referral-field {
    align-items: stretch;
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Dashboard-Affiliate/AffiliateDashboard.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;;;EAGE,oCAAoC;EACpC,yCAAyC;EACzC,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,uEAAuE;EACvE,uBAAuB;AACzB;;AAEA;;EAEE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EAGE,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,OAAO;EACP,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,wBAAwB;EACxB,sFAAsF;AACxF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;EAC7C,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,4DAA4D;EAC9D;AACF;;AAEA;EACE;;IAEE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;AACF","sourcesContent":[".affiliate-dashboard {\n  --affiliate-accent: #c93312;\n  --affiliate-ink: #171717;\n  --affiliate-muted: #667085;\n  --affiliate-border: #e8eaee;\n  --affiliate-surface: #fff;\n  color: var(--affiliate-ink);\n}\n\n.affiliate-dashboard__hero,\n.affiliate-dashboard__panel,\n.affiliate-dashboard__stat-card {\n  background: var(--affiliate-surface);\n  border: 1px solid var(--affiliate-border);\n  border-radius: 18px;\n  box-shadow: 0 4px 18px rgba(17, 24, 39, 0.05);\n}\n\n.affiliate-dashboard__hero {\n  background: linear-gradient(135deg, #fff8f3 0%, #fff 58%, #faf7f3 100%);\n  padding: 1.5rem 1.75rem;\n}\n\n.affiliate-dashboard__eyebrow,\n.affiliate-dashboard__panel-kicker {\n  color: var(--affiliate-accent);\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.affiliate-dashboard__title {\n  color: var(--affiliate-ink);\n  font-size: clamp(1.75rem, 3vw, 2.25rem);\n  font-weight: 700;\n  line-height: 1.15;\n}\n\n.affiliate-dashboard__subtitle,\n.affiliate-dashboard__panel-copy {\n  color: var(--affiliate-muted);\n  line-height: 1.55;\n}\n\n.affiliate-dashboard__stats-grid {\n  display: grid;\n  gap: 1rem;\n  grid-template-columns: repeat(1, minmax(0, 1fr));\n}\n\n.affiliate-dashboard__stat-card {\n  align-items: center;\n  display: flex;\n  gap: 1rem;\n  min-height: 110px;\n  padding: 1.1rem 1.2rem;\n}\n\n.affiliate-dashboard__stat-icon {\n  align-items: center;\n  border-radius: 14px;\n  display: inline-flex;\n  flex: 0 0 48px;\n  height: 48px;\n  justify-content: center;\n  width: 48px;\n}\n\n.affiliate-dashboard__stat-icon--earned {\n  background: #fff0eb;\n  color: #c93312;\n}\n\n.affiliate-dashboard__stat-icon--balance {\n  background: #eaf8ef;\n  color: #16803c;\n}\n\n.affiliate-dashboard__stat-icon--referrals {\n  background: #eef3ff;\n  color: #315cc5;\n}\n\n.affiliate-dashboard__stat-icon--commission {\n  background: #fff8dd;\n  color: #a06800;\n}\n\n.affiliate-dashboard__stat-label {\n  color: var(--affiliate-muted);\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.affiliate-dashboard__stat-value {\n  color: var(--affiliate-ink);\n  font-size: 1.3rem;\n  font-weight: 750;\n}\n\n.affiliate-dashboard__grid {\n  display: grid;\n  gap: 1rem;\n  grid-template-columns: 1fr;\n}\n\n.affiliate-dashboard__panel {\n  padding: 1.3rem;\n}\n\n.affiliate-dashboard__panel-heading,\n.affiliate-dashboard__stripe-heading,\n.affiliate-dashboard__button-row {\n  align-items: center;\n  display: flex;\n  gap: 0.75rem;\n}\n\n.affiliate-dashboard__panel-heading {\n  justify-content: space-between;\n}\n\n.affiliate-dashboard__panel-title {\n  color: var(--affiliate-ink);\n  font-size: 1.15rem;\n  font-weight: 700;\n}\n\n.affiliate-dashboard__status {\n  border-radius: 999px;\n  flex-shrink: 0;\n  font-size: 0.75rem;\n  font-weight: 700;\n  padding: 0.35rem 0.6rem;\n}\n\n.affiliate-dashboard__status--ready {\n  background: #eaf8ef;\n  color: #16803c;\n}\n\n.affiliate-dashboard__status--ended {\n  background: #f3f4f6;\n  color: #4b5563;\n}\n\n.affiliate-dashboard__referral-field {\n  align-items: center;\n  background: #f8f9fb;\n  border: 1px solid #e8eaee;\n  border-radius: 12px;\n  display: flex;\n  gap: 0.75rem;\n  padding: 0.65rem;\n}\n\n.affiliate-dashboard__referral-field code {\n  color: #475467;\n  flex: 1;\n  font-size: 0.8rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.affiliate-dashboard__button {\n  align-items: center;\n  border: 1px solid transparent;\n  border-radius: 9px;\n  cursor: pointer;\n  display: inline-flex;\n  font-size: 0.875rem;\n  font-weight: 700;\n  justify-content: center;\n  min-height: 38px;\n  padding: 0.55rem 0.85rem;\n  transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease;\n}\n\n.affiliate-dashboard__button:hover:not(:disabled) {\n  transform: translateY(-1px);\n}\n\n.affiliate-dashboard__button:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n.affiliate-dashboard__button--primary {\n  background: var(--affiliate-ink);\n  color: #fff;\n}\n\n.affiliate-dashboard__button--primary:hover:not(:disabled) {\n  background: #303030;\n}\n\n.affiliate-dashboard__button--secondary {\n  background: #fff;\n  border-color: #d9dde4;\n  color: #344054;\n}\n\n.affiliate-dashboard__button--secondary:hover:not(:disabled) {\n  background: #f7f8fa;\n  border-color: #b8bec8;\n}\n\n.affiliate-dashboard__hint {\n  color: #b54a11;\n  font-size: 0.82rem;\n  margin-top: 0.75rem;\n}\n\n.affiliate-dashboard__usage-row {\n  border-top: 1px solid var(--affiliate-border);\n  color: var(--affiliate-muted);\n  display: flex;\n  justify-content: space-between;\n  padding: 0.8rem 0;\n}\n\n.affiliate-dashboard__usage-row:first-of-type {\n  border-top: 0;\n}\n\n.affiliate-dashboard__usage-row strong {\n  color: var(--affiliate-ink);\n}\n\n.affiliate-dashboard__stripe-icon {\n  align-items: center;\n  background: #eef3ff;\n  border-radius: 12px;\n  color: #635bff;\n  display: inline-flex;\n  height: 44px;\n  justify-content: center;\n  width: 44px;\n}\n\n.affiliate-dashboard__stripe-notice {\n  align-items: flex-start;\n  background: #f8f9fb;\n  border: 1px solid #e8eaee;\n  border-radius: 12px;\n  color: #475467;\n  display: flex;\n  font-size: 0.9rem;\n  gap: 0.6rem;\n  margin: 1rem 0;\n  padding: 0.8rem;\n}\n\n.affiliate-dashboard__stripe-notice svg {\n  color: var(--affiliate-accent);\n  flex-shrink: 0;\n  margin-top: 0.05rem;\n}\n\n@media (min-width: 576px) {\n  .affiliate-dashboard__stats-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (min-width: 992px) {\n  .affiliate-dashboard__stats-grid {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n\n  .affiliate-dashboard__grid {\n    grid-template-columns: minmax(0, 1.6fr) minmax(280px, 0.8fr);\n  }\n}\n\n@media (max-width: 575px) {\n  .affiliate-dashboard__hero,\n  .affiliate-dashboard__panel {\n    padding: 1rem;\n  }\n\n  .affiliate-dashboard__panel-heading {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .affiliate-dashboard__referral-field {\n    align-items: stretch;\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
